import React, { createContext, Dispatch, ReactNode, useReducer } from 'react';
import { initialState, paginasCustomizadasReducer, PaginasCustomizadasState } from './paginas-customizadas-reducer';

type PaginasCustomizadasContextType = {
    paginasCustomizadasState: PaginasCustomizadasState;
    paginasCustomizadasDispatch: Dispatch<any>;
};

export const PaginasCustomizadasContext = createContext<PaginasCustomizadasContextType>({
    paginasCustomizadasState: initialState,
    paginasCustomizadasDispatch: () => null,
});

type PaginasCustomizadasProviderProps = {
    children: ReactNode;
};

export const PaginasCustomizadasProvider: React.FC<PaginasCustomizadasProviderProps> = ({ children }) => {
    const [paginasCustomizadasState, paginasCustomizadasDispatch] = useReducer(
        paginasCustomizadasReducer,
        initialState
    );

    return (
        <PaginasCustomizadasContext.Provider
            value={{
                paginasCustomizadasState,
                paginasCustomizadasDispatch,
            }}
        >
            {children}
        </PaginasCustomizadasContext.Provider>
    );
};
